import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { ZDrawScheduleSelect, ZDrawSelect, ZDrawTypeSelect } from '../draw';
import { ZLeaderboardPrizeDetails } from './models';

const c = initContract();

export const publicLeaderboardContract = c.router(
  {
    getCurrentLeaderboardDraw: {
      method: 'GET',
      path: '/current',
      responses: {
        200: z.object({
          draw: z.object({
            draw_type: ZDrawTypeSelect,
            draw_schedule: ZDrawScheduleSelect,
            draw: ZDrawSelect,
            prize: ZLeaderboardPrizeDetails,
          }),
        }),
        404: c.type<{ message: string }>(),
      },
    },
    getLeaderboardRanking: {
      method: 'GET',
      path: '/ranking',
      query: z.object({
        draw_id: z.coerce.number().optional(),
        limit: z.optional(z.coerce.number()),
      }),
      responses: {
        200:
          // grouped by rank - players with the same total points would have the same rank
          z.object({
            leaderboard: z
              .object({
                position: z.number(),
                positionLeaderboardRows: z
                  .object({
                    rank: z.number(),
                    leaderboard_username: z.string().nullable(),
                    leaderboard_photo_location: z.string().nullable(),
                    initials: z.string().nullable(),
                    points: z.number(),
                  })
                  .array(),
              })
              .array(),
          }),
        400: c.type<{ message: string }>(),
      },
    },
    getPointsBreakdown: {
      method: 'GET',
      path: '/points-breakdown',
      query: z.object({ user_id: z.string() }),
      responses: {
        200: z.object({
          breakdown: z.array(
            z.object({
              id: z.string(),
              created_at: z.date(),
              points: z.number(),
              // Add more fields if you extract them from entry JSON
            }),
          ),
        }),
        400: c.type<{ message: string }>(),
      },
    },
    getPointsTotalForUser: {
      method: 'GET',
      path: '/points-total',
      query: z.object({ user_id: z.string() }),
      responses: {
        200: z.object({ pointsTotal: z.number() }),
        400: c.type<{ message: string }>(),
      },
    },
    getLastMonthsWinners: {
      method: 'GET',
      path: '/last-months-winners',
      responses: {
        200: z.object({
          success: z.boolean(),
          data: z
            .object({
              drawDate: z.coerce.date().nullable(),
              prize: ZLeaderboardPrizeDetails,
              positionWinners: z.array(
                z.object({
                  rank: z.number(),
                  leaderboard_username: z.string().nullable(),
                  leaderboard_photo_location: z.string().nullable(),
                  initials: z.string(),
                  points: z.number(),
                  // Add more fields if your service returns them
                }),
              ),
              raffleWinner: z
                .object({
                  leaderboard_username: z.string().nullable(),
                  leaderboard_photo_location: z.string().nullable(),
                  initials: z.string(),
                })
                .nullable(),
            })
            .nullable(),
        }),
      },
    },
  },
  {
    pathPrefix: '/public',
    strictStatusCodes: true,
  },
);
